import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Header from "../common/header";
import Sidebar from "../common/sidebar";
import Breadcrumb from "../common/menuGuide";
import { formatPhone } from "../../utils/dateManage";
import alertUtils from "../../utils/utils";

function HistoryDetailPage() {
    const navigate = useNavigate();
    const currentPath = window.location.pathname;

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [detail, setDetail] = useState(null);

    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    const handleBreadcrumbClick = (item, index) => {
        if (index === 0) {
            setSidebarOpen(true);
        }
    };

    useEffect(() => {
        const savedData = sessionStorage.getItem("historyDetailData");

        if (!savedData) {
            alertUtils.warning("상세 데이터가 없습니다.");
            navigate("/history", { replace: true });
            return;
        }

        try {
            const parsed = JSON.parse(savedData);
            setDetail(parsed);
        } catch (error) {
            console.error("상세 데이터 파싱 실패:", error);
            alertUtils.error("상세 데이터를 불러오지 못했습니다.");
            navigate("/history", { replace: true });
        }
    }, [navigate]);

    const mapCnslResult = (value) => {
        if (value === "C") return "상담완료";
        if (value === "T") return "업무이관";
        return value || "";
    };

    const backToList = () => {
        navigate("/history", { state: { restore: true } });
    };

    if (!detail) return null;

    return (
        <div className="container">
            <Header
                isSidebarOpen={sidebarOpen}
                onMenuToggle={() => setSidebarOpen((prev) => !prev)}
            />

            {sidebarOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            <Sidebar
                isOpen={sidebarOpen}
                onClose={closeSidebar}
                currentPath={currentPath}
            />

            <main className="content">
                <Breadcrumb items={["상담 관리", "상담이력조회", "상담이력 상세"]}
                            onItemClick={(item, index) => {
                                if (index === 0) {
                                    handleBreadcrumbClick(item, index)
                                }

                                if (index === 1) {
                                    navigate("/history");
                                }
                            }}
                />

                <section className="page">
                    <div className="title-container">
                        <h1>상담이력 상세</h1>

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={backToList}
                        >
                            목록
                        </button>
                    </div>

                    <table className="detail-table">
                        <tbody>
                        <tr>
                            <th>호텔명</th>
                            <td>{detail?.serviceGroupName || ""}</td>
                        </tr>

                        <tr>
                            <th>접수일시</th>
                            <td>{detail?.registDate || ""}</td>
                        </tr>

                        {/*<tr>
                            <th>접수자</th>
                            <td>{detail?.userName || ""}</td>
                        </tr>*/}

                        <tr>
                            <th>상담채널</th>
                            <td>{detail?.cnslChannelName || ""}</td>
                        </tr>

                        <tr>
                            <th>상담유형</th>
                            <td>{detail?.cnslTypeName || ""}</td>
                        </tr>

                        <tr>
                            <th>고객명</th>
                            <td>{detail?.customerName || ""}</td>
                        </tr>

                        <tr>
                            <th>연락처</th>
                            <td>{detail?.customerTelNo ? formatPhone(detail.customerTelNo) : "-"}</td>
                        </tr>

                        <tr>
                            <th>객실호수</th>
                            <td>{detail?.etc1 || ""}</td>
                        </tr>

                        <tr>
                            <th>상담결과</th>
                            <td>{mapCnslResult(detail?.cnslResult)}</td>
                        </tr>

                        <tr>
                            <th>상담분류</th>
                            <td>{(detail.categoryName1 || '') + " > " +
                                (detail.categoryName2 || '') + " > " +
                                (detail.categoryName3 || '')}</td>
                        </tr>

                        <tr>
                            <th>문의내용</th>
                            <td className="detail-textarea">{detail?.inquiry || ""}</td>
                        </tr>

                        <tr>
                            <th>답변내용</th>
                            <td className="detail-textarea">{detail?.answer || ""}</td>
                        </tr>

                        <tr>
                            <th>메모</th>
                            <td className="detail-textarea">{detail?.memo || ""}</td>
                        </tr>
                        </tbody>
                    </table>
                </section>
            </main>
        </div>
    );
}

export default HistoryDetailPage;